import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import FlexSeparator from '@shared/helpers/flex-separator';
import UnstyledHeading from '@components/shared/unstyled-heading';
import SectionItem from './section-item';

import { getMenuConfig, getPortal } from '../selectors';

import { isMenuSectionActive } from '@utils/dashboard-details-utils';
import { verifyPermissions } from '@utils/permission-utils';

import styles from './menu.scss';

const PORTAL_NAV_HEADER_ID = 'portal-nav-header';

const PortalMenu = ({currentDataType, currentSubType}) => {
  const portal = useSelector(state => getPortal(state, currentDataType));
  const menuConfig = useSelector(state => getMenuConfig(state, currentDataType));

  return (
    <nav className={styles.dashboardMenuContainer} aria-labelledby={PORTAL_NAV_HEADER_ID}>
      <UnstyledHeading rank={2} id={PORTAL_NAV_HEADER_ID} ariaOnly>{portal} pages</UnstyledHeading>
      {menuConfig.map(section => {
        const { items, permissions, title } = section;
        if (!verifyPermissions(permissions)) {
          return null;
        }
        return (
          <div key={title}>
            <List>
              <ListSubheader
                classes={{
                  root: classNames(styles.title, {[isMenuSectionActive(section, currentDataType)]: styles.activeHeader})
                }}
              >
                {title}
              </ListSubheader>
              {items.map(item => (
                <SectionItem
                  key={`${item.type}-${item.subtype}`}
                  sectionItem={item}
                  currentDataType={currentDataType}
                  currentSubType={currentSubType}
                />
              ))}
            </List>
          </div>
        );
      })}
      <FlexSeparator />
    </nav>
  );
};

PortalMenu.propTypes = {
  currentDataType: PropTypes.string,
  currentSubType: PropTypes.string
};

export default memo(PortalMenu);
